import React, { useState, useEffect, Fragment } from "react";
import { 
    View, Text,
    StyleSheet
} from "react-native";
import { FONT } from "../../../value/staticValues";

import { ReactComponent as PrevCheckImg } from "../../../img/ico-step-check.svg";

interface StepLineProps {
    stepIndex: number;
    stepCount: number;
    stepLabels: string[];
}

export default function StepLine(props:StepLineProps) {
    return (
        <View style={{
            alignItems: "center", justifyContent: "center",
            width: 800, height: 120,
            marginLeft: -40,
            backgroundColor: "#f5f6fa",
        }}>
            <View style={style.backgroundContainer}>
            {
                props.stepLabels.map((label, index) => {
                    let icon = <div></div>; 
                    let lineStyle = className.stepLine;
                    
                    if(index === props.stepIndex) {
                        icon = <div key={index+100000} style={className.stepCurrentIcon}></div>;
                        
                    } else if(index < props.stepIndex) {
                        icon = <div key={index+100000} style={className.stepPrevIcon}>
                            <PrevCheckImg key={index+110000} style={{width: "24px", height: "24px"}}/>
                        </div>
                        lineStyle = className.stepLineActive;
                        
                    } else {
                        icon = <div key={index+100000} style={className.stepNextIcon}></div>;
                       
                    }
                    return (
                        <Fragment key={index + 160000}>
                            <View 
                                key={index+120000}
                                style={{ flexDirection: "row", alignItems: "center" }}
                            >
                                {
                                    icon
                                }
                                {
                                    index + 1 < props.stepCount ?
                                        <div key={index+130000} style={lineStyle}></div>
                                    : null
                                }
                            </View>
                        </Fragment>
                    )
                })
            }
            </View>
            <View style={style.backgroundContainer}>
            {
                props.stepLabels.map((label, index) => {
                    let labelStyle = style.stepLabel;
                    if(index === props.stepIndex) {
                    
                        labelStyle = style.stepLabelActive;
                    } else if(index < props.stepIndex) {
                     
                        labelStyle = style.stepLabelActive;
                    } else {
                    
                        labelStyle = style.stepLabel;
                    }
                    return (
                        <Fragment key={index + 170000}>
                            {
                                <View 
                                    key={index+140000} 
                                    style={{alignItems: "center", width: 145, marginTop: 13}}
                                >
                                    <Text key={index+150000} style={labelStyle}>{label}</Text>
                                </View>
                            }
                        </Fragment>
                    )
                })
            }
            </View>
        </View>
    )
}


const style = StyleSheet.create({
    backgroundContainer: {
        flexDirection: "row", alignItems: "center", justifyContent: "center",
    },
    stepLabelActive: {
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        color: "#3c5df2",
        textAlign: "center"
    },
    stepLabel: {
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        color: "#c6cbd4",
        textAlign: "center"
    }
});

const className = {
    stepPrevIcon: {
        width: "24px",
        height: "24px",
        borderRadius: "25px",
        backgroundColor: "#4a77ff"
    },
    stepCurrentIcon: {
        width: "12px",
        height: "12px",
        borderRadius: "25px",
        border:"solid 6px #fff",
        boxShadow: "2px 5px 10px 0 rgba(74, 119, 255, 0.5)",
        backgroundColor: "#4a77ff"
    },
    stepNextIcon: {
        width: "24px",
        height: "24px",
        borderRadius: "25px",
        backgroundColor: "#d8dde6"
    },
    stepLineActive: {
        width: "120px",
        border: "solid 1px #3c5df2"
    },
    stepLine: {
        width: "120px",
        border: "solid 1px #d8dde6"
    }
};